import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loader.service';
import { Subscription } from 'rxjs';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
/**
 * LoadingComponent  used to for creating the loader on screen.
 */
@Component({
  selector: 'app-loading',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoadingComponent implements OnInit, OnDestroy {
  loading = false;
  loadingSubscription: Subscription;

  // @Input() loadingInput ;
  constructor(private loadingService: LoadingService) {}

  // Initializing the component before loading
  ngOnInit() {
    this.loadingSubscription = this.loadingService.loadingStatus.subscribe(
      (value) => {
        this.loading = value;
      }
    );
   // this.loading = this.loadingInput;
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }
}
